// userSelectors.js

export const selectLoading = (state) => state.myProfile.loading;
export const selectSuccessMsg = (state) => state.myProfile.successMsg;